import { FC } from 'react';
import { Container, Placeholder } from '@/components';

import styles from './specialsslider.module.scss';

const PromoCarouselSkeleton: FC = () => {
  const renderSkeletonCard = (index: number) => (
    <div className={(styles.special, styles.special__placeholder)} key={index}>
      <Placeholder className={styles.special__placeholder_image} />
      <Placeholder className={styles.special__placeholder_title} />
      <Placeholder className={styles.special__placeholder_code} />
    </div>
  );

  return (
    <section>
      <Container className={styles.promo__carousel__skeleton}>
        {Array.from({ length: 15 }).map((_, index) =>
          renderSkeletonCard(index),
        )}
      </Container>
    </section>
  );
};

export default PromoCarouselSkeleton;
